import * as z from 'zod';
import { suretyBondFormTypeSchema, fileExtensionSchema, fileTypeSchema } from '../../../enums.mjs';
import { fileId, suretyBondFormTemplateId } from '../../../types/opaque.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            templateId: suretyBondFormTemplateId.optional(),
            upload: z
                .object({
                type: suretyBondFormTypeSchema,
                files: z.array(z.object({
                    id: fileId,
                    name: z.string(),
                    extension: fileExtensionSchema,
                    types: z.array(fileTypeSchema),
                    typesConfirmedByAdmin: z.boolean(),
                })),
            })
                .optional(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Upload;
(function (Upload) {
    (function (AgentIssue) {
        (function (Request) {
            Request.schema = z.object({
                fileId: fileId,
            });
        })(AgentIssue.Request || (AgentIssue.Request = {}));
    })(Upload.AgentIssue || (Upload.AgentIssue = {}));
})(Upload || (Upload = {}));
var Update;
(function (Update) {
    (function (Request) {
        const templateSchema = z.object({
            templateId: suretyBondFormTemplateId,
            bondFormType: z.literal(null),
            uploadedFileIds: z.array(fileId).min(0).max(0),
        });
        const uploadedFileSchema = z.object({
            templateId: z.literal(null),
            uploadedFileIds: z.array(fileId).nonempty(),
            bondFormType: suretyBondFormTypeSchema,
        });
        const partialSchema = z.object({
            templateId: z.literal(null),
            bondFormType: z.literal(null),
            uploadedFileIds: z.array(fileId).min(0).max(0),
        });
        Request.schema = z.union([templateSchema, uploadedFileSchema, partialSchema]);
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));

export { Get, Update, Upload };
